import React from 'react';
import HealthCenterForm from '../components/HealthCenterForm'
import axios from 'axios'
import { Table, Input, Button,Collapse,Popover,Popconfirm,message,Spin,Modal } from 'antd';
import Highlighter from 'react-highlight-words';
import Icon from '@ant-design/icons';
import { SearchOutlined,DeleteOutlined,FundViewOutlined,LoadingOutlined,DownloadOutlined,PrinterOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import * as serverconfig from '../../serverconn'
import HUbQrCodeView from './HubQRCodeView'
import ReactToPrint from 'react-to-print';
import ReactExport from "@ibrahimrahmani/react-export-excel";
import { Row, Col } from 'reactstrap';
import moment from 'moment';

var CryptoJS = require("crypto-js");

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const { Panel } = Collapse;
const antIcon = <LoadingOutlined style={{ fontSize: 60 }} spin />;

function callback(key) {
  console.log(key);
}


var token= ''
var sacco= ''

// Improved printable component for the health center table
class PrintableHealthCenterTable extends React.Component {
  state = {
    companyprofile: {},
  };

  componentDidMount() {
    let token = localStorage.getItem("token") || '';
    axios.defaults.headers = {
      "Content-Type": "application/json",
      Authorization: `Token ${token}`,
    };
    axios.get(serverconfig.backendserverurl + `/api/app_profile/1`).then((res) => {
      this.setState({ companyprofile: res.data });
    });
  }

  render() {
    const { columns, data } = this.props;
    const { companyprofile } = this.state;
    // Filter out the 'Action' column for printing
    const printableColumns = columns.filter(col => col.title !== 'Action');
    return (
      <div style={{ padding: '30px', fontFamily: 'Arial, sans-serif', backgroundColor: 'white' }}>
        {/* Header Section */}
        <div style={{ borderBottom: '3px solid #1890ff', paddingBottom: '20px', marginBottom: '30px' }}>
          <Row>
            <Col xs="3" sm="3" lg="3">
              <img
                height="80"
                width="100"
                alt="Logo"
                src={companyprofile.company_logo}
                style={{ border: '1px solid #ddd', borderRadius: '5px' }}
              />
            </Col>
            <Col xs="9" sm="9" lg="9">
              <div style={{ textAlign: 'left' }}>
                <h2 style={{ fontWeight: 'bold', color: '#1890ff', margin: '0', fontSize: '24px' }}>{companyprofile.system_name}</h2>
                <p style={{ margin: '5px 0', fontSize: '14px', color: '#666' }}>
                  <strong>Tel:</strong> {companyprofile.RegisteredPhoneNumber1}
                </p>
                <p style={{ margin: '5px 0', fontSize: '14px', color: '#666' }}>
                  <strong>Email:</strong> {companyprofile.company_email}
                </p>
                <p style={{ margin: '5px 0', fontSize: '12px', color: '#999' }}>
                  Generated on: {moment().format('DD/MM/YYYY')} at {moment().format('HH:mm')}
                </p>
              </div>
            </Col>
          </Row>
        </div>

        {/* Report Title and Summary */}
        <div style={{ textAlign: 'center', marginBottom: '25px' }}>
          <h2
            style={{
              fontWeight: 'bold',
              color: '#333',
              margin: '0',
              fontSize: '20px',
              textTransform: 'uppercase',
              letterSpacing: '1px',
            }}
          >
            Health Centers Report
          </h2>
          <p style={{ fontSize: '14px', color: '#666', margin: '8px 0' }}>
            Total Health Centers: <strong>{data.length}</strong>
          </p>
        </div>

        {/* Styled Table */}
        <table style={{ width: '100%', borderCollapse: 'collapse', background: 'white', fontSize: '11px' }}>
          <thead style={{ backgroundColor: '#f8f9fa' }}>
            <tr>
              <th style={{ padding: '8px 6px', fontWeight: 'bold', border: '1px solid #dee2e6', textAlign: 'center' }}>#</th>
              {printableColumns.map((col, idx) => (
                <th
                  key={col.dataIndex || idx}
                  style={{
                    padding: '8px 6px',
                    fontWeight: 'bold',
                    border: '1px solid #dee2e6',
                    textAlign: 'center',
                    background: 'linear-gradient(135deg, #0092ff 0%, #0066cc 100%)',
                    color: 'white',
                    fontSize: '10px',
                    textTransform: 'uppercase',
                  }}
                >
                  {col.title}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.map((item, index) => (
              <tr key={item.id || index} style={{ backgroundColor: index % 2 === 0 ? '#fff' : '#f8f9fa' }}>
                <td style={{ padding: '6px', textAlign: 'center', border: '1px solid #dee2e6', fontWeight: '500' }}>{index + 1}</td>
                {printableColumns.map((col, idx) => (
                  <td
                    key={col.dataIndex || idx}
                    style={{ border: '1px solid #dee2e6', padding: '6px', fontSize: '10px', textAlign: 'center' }}
                  >
                    {item[col.dataIndex] || ''}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>

        {/* Footer Section */}
        <div style={{ marginTop: '30px', borderTop: '2px solid #f0f0f0', paddingTop: '15px' }}>
          <Row>
            <Col xs="6" sm="6" lg="6">
              <div style={{ fontSize: '12px', color: '#666' }}>
                <p><strong>Report Summary:</strong></p>
                <p>• Total Health Centers: {data.length}</p>
              </div>
            </Col>
            <Col xs="6" sm="6" lg="6">
              <div style={{ textAlign: 'right', fontSize: '11px', color: '#999' }}>
                <p>This is a computer-generated report.</p>
                <p>© {moment().format('YYYY')} {companyprofile.system_name}</p>
                <p>Generated by: Umoja Health Center Management System</p>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

class HealthCenterList extends React.Component {
  state = {
    searchText: '',
    searchedColumn: '',
    healthcentres: [],
    datarequested:true,
    selected_record:{}


  };

  componentDidMount(){
    if(localStorage.getItem("sacco")){
       sacco= CryptoJS.AES.decrypt(localStorage.getItem("sacco") , 'my-secret-key@12345').toString(CryptoJS.enc.Utf8)
    }else{
       sacco= ''
    }
    
    if(localStorage.getItem("token")){
       token= localStorage.getItem("token")
    }else{
       token= ''
    }

    axios.defaults.headers={
      "Content-Type":"application/json",
      Authorization:`Token ${token}`
    }

    axios.get(serverconfig.backendserverurl+`/api/healthcentres`)
    .then(res => {
        this.setState({
            healthcentres:res.data
        })
        this.setState({datarequested:false})

    })
}

getColumnSearchProps = dataIndex => ({
  filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
    <div style={{ padding: 8 }}>
      <Input
        ref={node => {
          this.searchInput = node;
        }}
        placeholder={`Search ${dataIndex}`}
        value={selectedKeys[0]}
        onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
        onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
        style={{ width: 188, marginBottom: 8, display: 'block' }}
      />
      <Button
        type="primary"
        onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
        icon={<SearchOutlined />}
        size="small"
        style={{ width: 90, marginRight: 8 }}
      >
        Search
      </Button>
      <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>
        Reset
      </Button>
    </div>
  ),
  filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
  onFilter: (value, record) =>
    record[dataIndex]
      .toString()
      .toLowerCase()
      .includes(value.toLowerCase()),
  onFilterDropdownVisibleChange: visible => {
    if (visible) {
      setTimeout(() => this.searchInput.select());
    }
  },
  render: text =>
    this.state.searchedColumn === dataIndex ? (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[this.state.searchText]}
        autoEscape
        textToHighlight={text.toString()}
      />
    ) : (
      text
    ),
});

handleSearch = (selectedKeys, confirm, dataIndex) => {
  confirm();
  this.setState({
    searchText: selectedKeys[0],
    searchedColumn: dataIndex,
  });
};

handleReset = clearFilters => {
  clearFilters();
  this.setState({ searchText: '' });
};

    //////////////////////////////////////////////////
  //handle delete here
  handleDelete = id => {
    axios.delete(`${serverconfig.backendserverurl}/api/healthcentres/${id}`).then(res =>{
      window.location.reload(false)
      message.info("successfully deleted") 
     }
     );
  };

  render() {
    const columns = [
      {
        title: 'Name',
        dataIndex: 'name',
        key: 'id',
        ...this.getColumnSearchProps('name'),
      },

      {
        title: 'Code',
        dataIndex: 'HC_code',
        key: 'id',
        ...this.getColumnSearchProps('HC_code'),
      },
     
      {
        title: 'Collection hub',
        dataIndex: 'hub_name',
        key: 'id',
        ...this.getColumnSearchProps('hub_name'),
      },
      {
        title: 'District',
        dataIndex: 'district',
        key: 'id',
        ...this.getColumnSearchProps('district'),
      },

      {
        title: 'Contact person name',
        dataIndex: 'contactperson_name',
        key: 'id',
      },
      {
        title: 'Contact person tel',
        dataIndex: 'contactperson_phone',
        key: 'id',
      },
      {
        title: 'Address latitude',
        dataIndex: 'location_latitude',
        key: 'id',
      },
      {
        title: 'Address longitude',
        dataIndex: 'location_longitude',
        key: 'id',
      },
      {
        title: 'Sub hub',
        dataIndex: 'sub_hub',
        key: 'id',
        render: (text,record) =><span>{record.sub_hub? 'Yes' : 'No'}</span>
      },
      {
        title: 'Action',
        dataIndex: 'id',
        key: 'id',
        render: (text,record) =>
        <p>
        <Popover content={<p>Click here to edit,view details</p>} title="Edit,View">
         <Link to={`/healthcenters/${text}`}><FundViewOutlined style={{color:'blue'}}/></Link>
        </Popover>
        &nbsp;&nbsp;&nbsp;
        <Popover content={<p>Print/view</p>} title="View,print QR code">
         <FundViewOutlined style={{color:'green'}} 
          onClick={()=>{
          this.setState({show_qrModel:true})
          this.setState({selected_record:record})
          
          }} />
        </Popover>

        &nbsp;&nbsp;&nbsp;
        <Popover content={<p>Click here to delete client</p>} title="Delete">
        <Popconfirm title="Sure to delete?" onConfirm={() => this.handleDelete(text)}>
          <DeleteOutlined style={{color:'red'}}/>
         </Popconfirm>
        </Popover>
        </p>,
      }

    ];

    if(this.state.datarequested===true){
      return(
        <div style={{display: 'flex',  justifyContent:'center', alignItems:'center' }}>
        <Spin indicator={antIcon} />
        </div>
      )

    }else{
      return(
        <div>
          {/* Print and Excel Download Buttons */}
          <div style={{display:'flex',justifyContent:'flex-start',flexDirection:'row',marginBottom:16}}>
            <div style={{display: "none"}}>
              <PrintableHealthCenterTable
                columns={columns}
                data={this.state.healthcentres}
                ref={el => (this.componentRef = el)}
              />
            </div>
            <ReactToPrint
              trigger={() =>
                <Button type="primary" shape="round" icon={<PrinterOutlined />}>
                  Print
                </Button>
              }
              content={() => this.componentRef}
            />
            &nbsp;&nbsp;
            <ExcelFile
              filename={"UmojaIMC-HealthCenters"}
              element={<Button type='primary' icon={<DownloadOutlined/>} >Download Excel</Button>}
            >
              <ExcelSheet data={this.state.healthcentres} name="Health Centers">
                <ExcelColumn label="Name" value="name"/>
                <ExcelColumn label="Code" value="HC_code"/>
                <ExcelColumn label="Collection hub" value="hub_name"/>
                <ExcelColumn label="District" value="district"/>
                <ExcelColumn label="Contact person name" value="contactperson_name"/>
                <ExcelColumn label="Contact person tel" value="contactperson_phone"/>
                <ExcelColumn label="Address latitude" value="location_latitude"/>
                <ExcelColumn label="Address longitude" value="location_longitude"/>
                <ExcelColumn label="Sub hub" value="sub_hub"/>
                </ExcelSheet>
            </ExcelFile>
          </div>
            <Collapse defaultActiveKey={['1']} onChange={this.callback}>
            <Panel header="ALL SPOKES" key="1">
            <Table 
            columns={columns} 
            scroll={{ x: 1000 }}
            pagination={{showQuickJumper:true,showSizeChanger:true }}
            dataSource={this.state.healthcentres}
            bordered/>
             </Panel>
             </Collapse>
            <br />

            <Collapse defaultActiveKey={['0']} onChange={callback}>
            <Panel header="Collapse Panel to open Form" key="1">
              <h2>Create new spoke here</h2>
              <HealthCenterForm 
              requestType="post"
              idtypeID={null}
              btnText="Create"
              /> 
            </Panel>
            </Collapse>

              {
                this.state.show_qrModel ?
              <Modal              
                visible={this.state.show_qrModel}
                title="QR Code display"
                width={600}
                onCancel={()=>{this.setState({show_qrModel:false})}}

                footer={[
                  <Button key="back" onClick={()=>{this.setState({show_qrModel:false})}}>
                    Cancel
                  </Button>
                  ]}
                  >
                      <HUbQrCodeView 
                      selected_record={this.state.selected_record}
                      facility_type={'Healthcenter'}
                      facility_name={this.state.selected_record.name}
                      title={"QR Code for "+this.state.selected_record.name}
                      />
                 </Modal>

                : null
              }

        </div>
    )

    }

   
  }
}

export default HealthCenterList; 
